import React from 'react'
import { csx } from '@vtex/admin-ui'

export type ProductCarouselHeaderProps = React.HTMLAttributes<HTMLDivElement>

export const ProductCarouselHeader = ({
  children,
  ...props
}: ProductCarouselHeaderProps) => {
  return (
    <div
      className={csx({
        display: 'block',
        marginBottom: '$space-4',
        '@tablet': {
          marginBottom: '$space-5',
        },
      })}
      {...props}
    >
      {children}
    </div>
  )
}
